/*
  Hide and Show elements.

  display-hidden-class -> class to be toggled to hide and show element
  display-checked-class ->

*/
import { Controller } from '@hotwired/stimulus'


export default class extends Controller {
  static classes = [ 'hidden', 'checked', 'unchecked' ]

/*
  Show or Hide specific element.
  Target element ID should be added as data-element-id
*/
  toggle(event) {
    event.preventDefault()
    let elementId = event.currentTarget.dataset.elementId
    let element = document.getElementById(elementId)
    element.classList.toggle(this.hiddenClass)
  }

  showElement(event) {
    event.preventDefault()
    let elementId = event.currentTarget.dataset.elementId
    let element = document.getElementById(elementId)
    element.classList.remove(this.hiddenClass)
  }

/*
  toggleActive(event)
  - remove .active class from all elements in dom -> possible concurency issue
  - add .active to event target (usually a button)
  - add .hidden to all elements specified by elements-class from dataset
  - call the showElement function to display element based on element-id from dataset
*/
  toggleActive(event) {
    let elementsClass = event.currentTarget.dataset.elementsClass
    let options = document.querySelectorAll('.active-option')
    let elements = document.querySelectorAll(`.${elementsClass}`)

    const wasActive = event.currentTarget.classList.contains('active')

    options.forEach((option) => {
      option.classList.remove('active')
    })
    if (wasActive) {
      event.currentTarget.classList.remove('active')
    } else {
      event.currentTarget.classList.add('active')
    }

    elements = document.querySelectorAll(`.${elementsClass}`)
    elements.forEach((element) => {
      element.classList.add(this.hiddenClass)
    })

    if (!wasActive) { this.showElement(event) }
  }

/*
  toggleTruncate(event)
  - currentTarget is a button with data-element-id of text to truncate
  - inside this button are .chevron-up and .chevron-down elements to display truncated status
*/

  toggleTruncate(event) {
    let elementId = event.currentTarget.dataset.elementId
    let truncatedElement = document.querySelector(`#${elementId}`)

    if (truncatedElement.classList.contains('truncate')) {
      truncatedElement.classList.remove('truncate')
      event.currentTarget.querySelector('.chevron-down').classList.add('hidden')
      event.currentTarget.querySelector('.chevron-up').classList.remove('hidden')
    } else {
      truncatedElement.classList.add('truncate')
      event.currentTarget.querySelector('.chevron-up').classList.add('hidden')
      event.currentTarget.querySelector('.chevron-down').classList.remove('hidden')
    }
  }

/*
  loadMore(event)
  - consider closest '.list-container' element from event target
  - hide its inner '.paginated-list' sub-element
  - show its inner '.full-list' sub-element
*/
  loadMore(event) {
    let listContainer = event.currentTarget.closest('.list-container')
    let fullList = listContainer.querySelector('.full-list')
    let paginatedList = listContainer.querySelector('.paginated-list')

    paginatedList.classList.add(this.hiddenClass)
    fullList.classList.remove(this.hiddenClass)
  }

/*
  loadLess(event)
  - consider closest '.list-container' element from event target
  - hide its inner '.full-list' sub-element
  - show its inner '.paginated-list' sub-element
*/
  loadLess(event) {
    let listContainer = event.currentTarget.closest('.list-container')
    let fullList = listContainer.querySelector('.full-list')
    let paginatedList = listContainer.querySelector('.paginated-list')

    fullList.classList.add(this.hiddenClass)
    paginatedList.classList.remove(this.hiddenClass)
  }

/*
  Show or Hide more than one element.
  Target elements classes should be added as data-elements-class
*/
  toggleMultiple(event){
    event.preventDefault()
    let elementsClass = event.currentTarget.dataset.elementsClass
    let elements = document.querySelectorAll(`.${elementsClass}`)
    elements.forEach((element) => {
      element.classList.toggle(this.hiddenClass)
    })
  }

/*
  Show or Hide specific element based on selected <option> from <select>.
  data-index -> index of the <option> element that triggles the function
  data-element-id -> ID of the element to be hidden / displayed.
*/

  toggleOnSelect(event){
    let options = event.target.options
    let index = event.currentTarget.dataset.index
    let selectedValue = options[options.selectedIndex].value
    let elementId = event.currentTarget.dataset.elementId
    let element = document.getElementById(elementId)
    if(index == selectedValue){
      element.classList.remove(this.hiddenClass)
    } else {
      element.classList.add(this.hiddenClass)
    }
  }

/*
  Add data-checked-class to element if it's checked.
  Add data-uncheched-class to element if it's not checked.

  Function to be renamed because we can add any class we want to checked elements, not only color classes.
*/

  changeColor(event){
    let elementId = event.currentTarget.dataset.elementId
    let element = document.getElementById(elementId)
    let multiple = event.currentTarget.dataset.multiple

    if(multiple == "false"){
      this.uncheckAll()
    }
    this.toggleCheckedClass(element)
  }


/*
  Functions to be refactored after dragonfly upgrade fix.
*/
  changeMultipleColors(event){
    let elements = document.querySelectorAll('[data-color-change]');
    elements.forEach(element => {
      this.toggleCheckedClass(element)
    })
  }

  toggleCheckedClass(element){
    element.classList.toggle(this.uncheckedClass)
    element.classList.toggle(this.checkedClass)
  }

  uncheckAll(){
    let elements = document.querySelectorAll('[data-checked]');
    elements.forEach(element => {
      element.classList.remove(this.checkedClass)
      element.classList.add(this.uncheckedClass)
    })
  }

  toggleInput(event){
    let elementInputClass = event.currentTarget.dataset.elementInputClass
    let elements = document.querySelectorAll(`.${elementInputClass}`)
    elements.forEach((element) => {
      element.disabled = !element.disabled
    })
  }

  toggleClass(event) {
    event.preventDefault()
    let elementId = event.currentTarget.dataset.element
    let className = event.currentTarget.dataset.class
    let element = document.getElementById(elementId)
    element.classList.toggle(className)
  }
}
